<mat-card *appHasRoles="['admin', 'manager', 'agent', 'compliance']" class="content-card">
    <mat-card-header>
        <mat-card-title>
            <h5>{{caption}}</h5>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="list-item" fxLayout="row" fxLayoutGap="10px" >
          <label fxFlex="17" class="c1 secondary">Date</label>
          <label fxFlex="16" class="c2 secondary">Type</label>
          <label fxFlex="17" class="c3 secondary">Name</label>
          <label fxFlex="17" class="c4 secondary">Ip Address</label>
          <label fxFlex="19" class="c5 secondary">Field</label>
          <label fxFlex="14" class="c6 secondary">Old Value</label>
          <label fxFlex="1"></label>


        </div>

      <ng-container *ngIf="isLoading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-container>

        <div id="scroll">
          <div class="list-item" fxLayout="row" fxLayoutGap="10px" *ngFor="let log of logs" >
              <label class="c1" fxFlex="17" >{{ log.date | date: "dd.MM.yyyy HH:mm" }}</label>
              <label class="c2" fxFlex="16" >{{ eventLogShowService.getLogTypeName(log.type) }}</label>
              <label class="c3" fxFlex="17" >{{ log.userFullName }}</label>
              <label class="c4" fxFlex="17" >{{ log.ipAddress }}</label>
              <label class="c5" fxFlex="19" >{{ log.field }}</label>
              <label class="c6" fxFlex="14" >{{ log.oldValue }}<ng-container *ngIf="log.isSensitiveData && log.isAnonymized"> 🔒</ng-container><ng-container *ngIf="log.isSensitiveData && !log.isAnonymized">🔹</ng-container></label>
          </div>
        </div>
      <div class="text-center mt-1 mb-1 w-100" *ngIf="!isLoading && (!logs || logs.length == 0)">
        <i>- none- </i>
      </div>
    </mat-card-content>
</mat-card>
